// eslint:disable max-func-body-length
// eslint:disable max-line-length
import * as React from 'react';
import { Component } from 'react';
import { IndicatorFactorsScreenRendererProps } from 'app/area/indicator-factors/item/types';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { ReadOnlyType } from 'app/area/indicator-factors/item/types';
import { Factor, ValidFrom } from 'app/area/indicator-factors/item/code-fields';
import {
  Substance, SubstanceUom, IndicatorSubstance, IndicatorSubstanceUom,
  Location, Unit, Source
} from 'app/area/indicator-factors/item/code-pickers';
import { IndicatorType } from 'app/area/indicator-factors/item/code-pickers/indicator-type';
import { Equipment } from 'app/area/indicator-factors/item/code-pickers/equipment';
import { CodetableItemMessages } from 'app/area/indicator-factors/item/codetable-item-messages';
import styles from 'app/area/indicator-factors/item/codetable-item-form.scss';
import { CodeFieldWireKey } from 'app/area/indicator-factors/types-store';
import { clearAllValidation } from 'app/area/indicator-factors/item/codetable-item-helpers';

export class IndicatorFactorsScreenRenderer extends Component<IndicatorFactorsScreenRendererProps> {

  private clearAllValidation = (codetableKey: CodeFieldWireKey) => {
    const { validation, clearValidation } = this.props;
    clearAllValidation({ codetableKey, validation, clearValidation });
  };

  public render() {
    const { breadcrumbs, actionType, translation, metadata, codeItem, validation = {}, codetableOptions,
      loadCodetableOptions, readOnlyConfig, loadOptions, options, shouldPrompt,
      updateByKey, resetValidation, savingCodetableItem,
      locale } = this.props;

    const readOnly = readOnlyConfig && readOnlyConfig[ReadOnlyType.all];

    return <div className={styles.codetableItemForm}>

      <MainGridContainer>
        <CodetableItemMessages
          actionType={actionType}
          shouldPrompt={shouldPrompt}
          savingCodetableItem={savingCodetableItem}
          validation={validation}
          translation={translation}
        />
        <div className={`row ${styles.spacing}`}>
          <Substance
            breadcrumbs={breadcrumbs}
            readOnly={readOnly}
            metadata={metadata}
            codeItem={codeItem}
            validation={validation}
            codetableOptions={codetableOptions}
            translation={translation}
            loadCodetableOptions={loadCodetableOptions}
            onChange={updateByKey}
            resetValidation={resetValidation}
            clearAllValidation={this.clearAllValidation} />

          <SubstanceUom
            breadcrumbs={breadcrumbs}
            readOnly={readOnly}
            metadata={metadata}
            codeItem={codeItem}
            validation={validation}
            codetableOptions={codetableOptions}
            options={options}
            translation={translation}
            loadCodetableOptions={loadCodetableOptions}
            loadOptions={loadOptions}
            onChange={updateByKey}
            resetValidation={resetValidation}
            clearAllValidation={this.clearAllValidation} />
        </div>

        <div className={`row ${styles.spacing}`}>
          <IndicatorSubstance
            breadcrumbs={breadcrumbs}
            readOnly={readOnly}
            metadata={metadata}
            codeItem={codeItem}
            validation={validation}
            codetableOptions={codetableOptions}
            translation={translation}
            loadCodetableOptions={loadCodetableOptions}
            onChange={updateByKey}
            resetValidation={resetValidation}
            clearAllValidation={this.clearAllValidation} />

          <IndicatorSubstanceUom
            breadcrumbs={breadcrumbs}
            readOnly={readOnly}
            metadata={metadata}
            codeItem={codeItem}
            validation={validation}
            options={options}
            codetableOptions={codetableOptions}
            translation={translation}
            loadCodetableOptions={loadCodetableOptions}
            loadOptions={loadOptions}
            onChange={updateByKey}
            resetValidation={resetValidation}
            clearAllValidation={this.clearAllValidation} />
        </div>

        <div className={`row ${styles.spacing}`}>
          <IndicatorType
            breadcrumbs={breadcrumbs}
            readOnly={readOnly}
            metadata={metadata}
            codeItem={codeItem}
            validation={validation}
            codetableOptions={codetableOptions}
            translation={translation}
            loadCodetableOptions={loadCodetableOptions}
            onChange={updateByKey}
            resetValidation={resetValidation}
            clearAllValidation={this.clearAllValidation} />

          <ValidFrom
            readOnly={readOnly}
            metadata={metadata}
            codeItem={codeItem}
            validation={validation}
            codetableOptions={codetableOptions}
            translation={translation}
            loadCodetableOptions={loadCodetableOptions}
            onChange={updateByKey}
            resetValidation={resetValidation}
            clearAllValidation={this.clearAllValidation}
            locale={locale} />

          <Factor
            readOnly={readOnly}
            metadata={metadata}
            codeItem={codeItem}
            validation={validation}
            translation={translation}
            locale={locale}
            onChange={updateByKey}
            resetValidation={resetValidation}
            clearAllValidationData={this.clearAllValidation}
          />
        </div>

        <div className="row">
          {metadata?.location && <Location
            readOnly={readOnly}
            metadata={metadata}
            codeItem={codeItem}
            validation={validation}
            codetableOptions={codetableOptions}
            translation={translation}
            loadCodetableOptions={loadCodetableOptions}
            onChange={updateByKey}
            resetValidation={resetValidation}
            clearAllValidation={this.clearAllValidation} />}

          {metadata?.unit && <Unit
            readOnly={readOnly}
            metadata={metadata}
            codeItem={codeItem}
            validation={validation}
            codetableOptions={codetableOptions}
            translation={translation}
            loadCodetableOptions={loadCodetableOptions}
            onChange={updateByKey}
            resetValidation={resetValidation}
            clearAllValidation={this.clearAllValidation} />}

          {metadata?.source && <Source
            readOnly={readOnly}
            metadata={metadata}
            codeItem={codeItem}
            validation={validation}
            codetableOptions={codetableOptions}
            translation={translation}
            loadCodetableOptions={loadCodetableOptions}
            onChange={updateByKey}
            resetValidation={resetValidation}
            clearAllValidation={this.clearAllValidation} />}

          {metadata?.equipment && <Equipment
            readOnly={readOnly}
            metadata={metadata}
            codeItem={codeItem}
            validation={validation}
            codetableOptions={codetableOptions}
            translation={translation}
            loadCodetableOptions={loadCodetableOptions}
            onChange={updateByKey}
            resetValidation={resetValidation}
            clearAllValidation={this.clearAllValidation} />}
        </div>
      </MainGridContainer>
    </div>;
  }
}
